import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/components/AfterResultBot.css";
import omnicareLogo from "../../assets/icons/logo.svg";
import doctorImage from "../../assets/images/doctor.png";
import backIcon from "../../assets/icons/back.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import sunIcon from "../../assets/icons/stars.svg"; // Placeholder for sun icon
import mapIcon from "../../assets/icons/coffee.svg"; // Placeholder for map icon

const AfterQuiz2 = () => {
  const navigate = useNavigate();

  const handleCareClick = () => {
    navigate("/thankyou?from=after-quiz-2");
  };

  const handleChatMoreClick = () => {
    navigate("/openai");
  };

  const handleBack = () => {
    navigate("/after-quiz/1");
  };
  return (
    <div className="after-result-bot-container">
      {/* Header */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration above divider */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="after-result-bot2-content">
        <h2 className="congrats-text">That is great!</h2>
        <div className="info-row">
          <img src={sunIcon} alt="Sun" className="info-icon" />
          <span>
            You can simply discuss your <u>quiz</u> results with them and ask for test referrals —they’ll guide you through the next steps.
          </span>
        </div>
        <div className="info-row">
          <img src={mapIcon} alt="Map" className="info-icon" />
          <span>
            You can also use the <a href="https://crucialcatch.cancer.org/locations/" className="info-link" target="_blank" rel="noopener noreferrer">Cancer Screening Locator</a> by the American Cancer Society to find nearby facilities. Just give them a call to ask about screenings and consultations.
          </span>
        </div>
      </div>

      <div className="after-result-bot2-buttons">
        <button className="care-button" onClick={handleCareClick}>
          <span className="answer-title">I See! I will take better care of myself</span>
        </button>
        <button className="chatmore-button" onClick={handleChatMoreClick}>
          <span className="answer-title">I want to chat more</span>
        </button>
      </div>
    </div>
  );
};

export default AfterQuiz2; 